import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import loadable from '@loadable/component';
import get from 'lodash/get';
import merge from 'lodash/merge';
import { HEADER_OFFSET } from '../../../constants';
import { BREAKPOINTS, getBreakpoint } from '../../../utils/commonHelper';
import { adsConfig, getTargeting } from './resources/adsConfig';
import adParams from './resources/adParams';
import { Ad } from '@dmm/react-common-components';
import AdProvider from '../../../components/Ads/AdProvider';
import {
  addLead,
  setEnhancedEcommerce,
  setProduct,
  openCarouselModal,
  trackContactFormOpen,
  setGenericEvent,
  setListingView,
  clearEcommerceData
} from '../../../store/actions/dataLayer';
import { createSearchAlert } from '../../../store/actions';
import { buildProduct } from '../../../utils/dataLayerHelper';
import BreadCrumb from '../../../components/BreadCrumb';
import ProductSchema from '../../../components/Schema/ProductSchema';
import Meta from '../../../components/Meta';
import { getBreadCrumb } from '../utils/breadcrumb';
import * as meta from '../utils/meta';
import DetailsContact from '../DetailsContact';
import DetailsManufacturer from '../DetailsManufacturer';
import DetailsManufacturerContact from '../DetailsManufacturerContact';
import DetailsSection from '../DetailsSection';
import DetailsSectionVariant1 from '../DetailsSection/Variant1';
import NextPrevious from '../NextPrevious';
import BoatSummary from '../BoatSummary';
import CarouselDisplayer from '../../../components/CarouselDisplayer';
import Sticky from '../../../components/Sticky';
import { CarouselButtonTray, ButtonTray } from '../ButtonTray';
import * as listingHelper from '../../../utils/listingHelper';
import { getCurrency, getCustomUom } from '../../../utils/uomHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { scrollTo } from '../../../utils/scrollTo';
import NextPreviousDataProvider from '../NextPreviousDataProvider';
import { PortalConfigContext, getConfig } from '../../../config/portal';
import messages from '../../../utils/translationMessages';
import {
  formatMessage as t,
  getCurrentBoats as bts,
  getCurrentLocale,
  getPortalName
} from '../../../utils/language';
import { withCookies, Cookies } from 'react-cookie';
import { getImmersiveTour } from '../../../utils/immersiveTourHelper';
import StickyContact from '../StickyContact';
import DealerLocator from '../../../components/DealerLocator';
import ImmersiveTourModal from '../../../components/ImmersiveTourModal';
import * as immersiveTourHelper from '../../../utils/immersiveTourHelper';
import SidePopUp from '../../../components/SidePopUP';
import SaveSearchFromDetails from '../../../components/SaveSearchFromDetails';
import './styles.css';
import { GetPreQualifiedModal } from '../../../components/GetPreQualified';
import { setCookie } from '../../../utils/cookies';
import { CookieType } from '@dmm/lib-node-cookies/dist/utils/trustarc';

import { calculateMonthlyPrice } from '../../../utils/trident';

const AdditionalLeadsModal = loadable(() =>
  import('../../../components/AdditionalLeadsModal')
);
const LiveVideoTourModal = loadable(() =>
  import('../../../components/LiveVideoTourModal')
);
const CarouselModal = loadable(() =>
  import('../../../components/CarouselModal')
);

let throttle;
class MainContent extends PureComponent {
  BROKER_SPOTLIGHT_CONTACT = 'Broker Spotlight';

  state = {
    breakpoint: 'desktop',
    showModalCarousel: false,
    carouselIndex: 0,
    showVideoTourForm: false,
    showContactModal: false,
    showModalPreQualified: false,
    scrolled: undefined,
    showImmersiveTourModal: false,
    trackLength: 0,
    hideSavedSearchPopup: true,
    showDealerLocatorModal: false,
    openBoatLoansComponent: 'boat-loans',
    openBoatLoansComponentCounter: 0,
    contactModal: {
      prePopulatedText: ''
    }
  };

  handleResize = () => {
    const winHeight = window.innerHeight;
    const docHeight = this.getDocHeight();
    this.setState({ trackLength: docHeight - winHeight });
  };

  handleScroll = () => {
    const {
      cookies,
      listing: { id: listingId }
    } = this.props;

    const showContactFormOnScroll = get(
      getConfig(),
      'supports.bdp.contactFormOnScroll',
      true
    );

    clearTimeout(throttle);
    // throttle code inside scroll to once every 25 milliseconds
    // this is used to prevent performance degradation
    throttle = setTimeout(() => {
      if (!cookies.cookies[listingId]) {
        const scrolled = this.getAmountScrolled();
        if (scrolled >= 60) {
          if (showContactFormOnScroll) {
            this.handleOpenContactModal(undefined, true);
          }

          const inOneDay = new Date();
          inOneDay.setDate(inOneDay.getDate() + 1);
          const options = {
            expires: inOneDay,
            path: '/',
            value: 1
          };
          setCookie(cookies, listingId, 1, options, CookieType.REQUIRED);
        }
      }
    }, 25);
  };
  getAmountScrolled() {
    const scrollTop = window.pageYOffset;
    return Math.floor((scrollTop / this.state.trackLength) * 100);
  }

  getDocHeight() {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  }

  handleOpenContactModal = (event, scrolled, data) => {
    let contactButtonOrigin;

    if (event?.target?.id === 'broker-spotlight-contact-button') {
      const { listing } = this.props;

      addLead(listing.owner.brokerSpotlightId, 'email lead', null);
      this.props.setEnhancedEcommerce(
        [bts().LISTING_PREMIUM_BROKER],
        listing.owner.brokerSpotlightId
      );

      contactButtonOrigin = this.BROKER_SPOTLIGHT_CONTACT;
    }

    this.setState({
      contactOrigin: contactButtonOrigin,
      showContactModal: true,
      hideSavedSearchPopup: true,
      scrolled,
      contactModal: {
        prePopulatedText: data?.prePopulatedText || ''
      }
    });
  };

  handleCloseContactModal = () => {
    this.setState({
      showContactModal: false,
      hideSavedSearchPopup: false
    });
  };

  handleBoatSummaryScroll = (scrolledPastBoatSummary) => {
    this.setState({ scrolledPastBoatSummary });
  };

  handleSummaryLocationLinkClicked = (componentCounter) => {
    this.setState({
      openLocationComponent: 'location-map',
      openLocationComponentCounter: componentCounter
    });
  };

  handleSummaryLoansButtonclicked = (componentCounter) => {
    this.setState({
      openBoatLoansComponent: 'boat-loans',
      openBoatLoansComponentCounter: componentCounter
    });
  };

  resizeHandler = () => {
    this.setState({
      breakpoint: getBreakpoint()
    });
  };

  hideModal = () => {
    scrollTo('#root-anchor');
    this.setState({ showModalCarousel: false });
  };

  showModal = (index = 0) => {
    this.props.openCarouselModal();
    this.setState({
      carouselIndex: index,
      showModalCarousel: true
    });
  };

  mapDetailsSectionVariants() {
    const subsectionOrder = get(this.context, 'supports.subsectionOrder', 0);
    switch (subsectionOrder) {
      case 1:
        return DetailsSectionVariant1;
      default:
        return DetailsSection;
    }
  }

  getCustomUom() {
    const {
      cookies,
      intl: { locale }
    } = this.props;
    const isDefaultLocaleUom = get(this.context, 'supports.defaultUoms', false);
    const supportedUoms = get(this.context, 'supportedUoms');
    const defaultLocaleUom = get(
      this.context,
      `languages.${locale}.defaultUom`
    );
    return getCustomUom(
      isDefaultLocaleUom,
      cookies,
      supportedUoms,
      defaultLocaleUom
    );
  }

  showModalPreQualified = (show) => {
    this.setState({ showModalPreQualified: show });
  };

  handleSummaryPaymentLinkClicked = (componentCounter) => {
    this.setState({
      openPaymentComponent: 'payment-calculator',
      openPaymentComponentCounter: componentCounter
    });
  };

  async componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();

    let { listing } = this.props;
    if (listing && listing.id) {
      this.props.setProduct(buildProduct(listing, 'boat'));
    }

    window.addEventListener('scroll', this.handleScroll);
    // GA4 Tracking for view_item event
    this.props.setListingView(listing.id);
  }

  componentDidUpdate(prevProps) {
    let { listing } = this.props;
    let prevListingId = get(prevProps, 'listing.id');
    if (listing && listing.id && prevListingId !== listing.id) {
      this.props.setProduct(buildProduct(listing, 'boat'));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.resizeHandler);
  }

  getPageAdsConfig() {
    const portalAdsConfig = get(this.context, 'pages.details.adsConfig', {});
    const selectedAds = Object.keys(portalAdsConfig).reduce(
      (resultAds, adsKey) => {
        resultAds[adsKey] = adsConfig[adsKey];
        return resultAds;
      },
      {}
    );
    return merge(portalAdsConfig, selectedAds);
  }

  toggleVideoTourModal() {
    this.setState({
      ...this.state,
      showVideoTourForm: !this.state.showVideoTourForm
    });
  }

  getCarouselButtonTrayProps(listing) {
    const showLiveVideoTourButton = get(
      this.context,
      'supports.showLiveVideoTourButton',
      false
    );
    const carouselButtonTrayProps = {
      listing,
      productType: 'boat',
      openCarouselModal: (index) => this.showModal(index)
    };
    if (
      showLiveVideoTourButton &&
      listingHelper.isAvailableForLiveVideoTour(listing)
    ) {
      carouselButtonTrayProps.openVideoTourModal = () =>
        this.toggleVideoTourModal();
    }

    return carouselButtonTrayProps;
  }

  getButtonTrayProps(listing) {
    const showLiveVideoTourButton = get(
      this.context,
      'supports.showLiveVideoTourButton',
      false
    );
    const buttonTrayProps = {
      listing,
      productType: 'boat'
    };
    if (
      showLiveVideoTourButton &&
      listingHelper.isAvailableForLiveVideoTour(listing)
    ) {
      buttonTrayProps.openVideoTourModal = () => this.toggleVideoTourModal();
    }

    return buttonTrayProps;
  }

  getSecondAdParams(showThirdAdbox, adReload, adParams) {
    const secondAdBoxParams = { ...adParams.sideBarAd2Params };
    if (showThirdAdbox) {
      secondAdBoxParams.reloadAd = adReload;
      secondAdBoxParams.targeting = { refresh: adReload.toString() };
    }

    return secondAdBoxParams;
  }

  checkIsEmailManufacturer() {
    const { listing } = this.props;
    const manufacturerListings = get(
      this.context,
      'supports.manufacturerListings',
      false
    );
    const isOemModel = get(listing, 'isOemModel', false);
    const emailManufacturer = get(
      listing,
      'oemDetails.emailManufacturer',
      false
    );
    const dealerLocator = get(listing, 'oemDetails.dealerLocator', false);

    return (
      manufacturerListings && isOemModel && emailManufacturer && !dealerLocator
    );
  }

  checkIsDealerLocator() {
    const { listing } = this.props;
    const manufacturerListings = get(
      this.context,
      'supports.manufacturerListings',
      false
    );
    const isOemModel = get(listing, 'isOemModel', false);
    const dealerLocator = get(listing, 'oemDetails.dealerLocator', false);

    return manufacturerListings && isOemModel && dealerLocator;
  }

  toggleDealerLocatorModal(active) {
    this.setState({ ...this.state, showDealerLocatorModal: active });
  }

  showManufacturerDetailsLayout() {
    const enableDealerLocatorV2 = get(
      this,
      'context.supports.enableDealerLocatorV2',
      false
    );
    const { listing } = this.props;

    if (enableDealerLocatorV2 && this.checkIsEmailManufacturer()) {
      return <DetailsManufacturerContact listing={listing} />;
    }
    if (enableDealerLocatorV2 && this.checkIsDealerLocator()) {
      return (
        <DetailsManufacturer
          manufacturerMakeLogo={get(listing, 'owner.logos.default')}
          findDealerLink={listing.findDealerLink}
          make={listing.make}
          brandId={get(listing, 'oemDetails.brandId')}
          onClick={
            /* istanbul ignore next */
            () => this.toggleDealerLocatorModal(true)
          }
          tracking={{
            setGenericEvent: this.props.setGenericEvent,
            clearEcommerceData: this.props.clearEcommerceData
          }}
        />
      );
    }
    return (
      <DetailsManufacturer
        manufacturerMakeLogo={get(listing, 'owner.logos.default')}
        findDealerLink={listing.findDealerLink}
        make={listing.make}
        tracking={{
          setGenericEvent: this.props.setGenericEvent,
          clearEcommerceData: this.props.clearEcommerceData
        }}
      />
    );
  }

  showManufacturerModal() {
    const { listing } = this.props;

    return (
      <div
        id="bdp-manufacturer-contact-modal"
        className="details-contact-modal manufacturer-contact-modal"
      >
        <div className="modal-wrapper">
          <button
            type="button"
            className="modal-close"
            onClick={this.handleCloseContactModal}
          >
            <span className="visuallyhidden">
              {t(messages.contactForm.close)}
            </span>
          </button>
          <DetailsManufacturerContact listing={listing} />
        </div>
      </div>
    );
  }

  showFindDealerButton() {
    const enableDealerLocatorV2 = get(
      this,
      'context.supports.enableDealerLocatorV2',
      false
    );
    const { listing } = this.props;

    if (enableDealerLocatorV2 && this.checkIsEmailManufacturer()) {
      return null;
    }
    if (enableDealerLocatorV2 && this.checkIsDealerLocator()) {
      const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDealerLocatorModal(true);
      };

      return (
        <div className="manufacturer-call-to-action">
          <a
            className="find-dealer-button"
            href={listing.findDealerLink}
            target="blank"
          >
            <button
              type="button"
              className="btn-action dealer-button"
              onClick={onClick}
            >
              {t(messages.detailsManufacturer.findDealerButton)}
            </button>
          </a>
        </div>
      );
    }
    return (
      <div className="manufacturer-call-to-action">
        <a
          className="find-dealer-button"
          href={listing.findDealerLink}
          target="blank"
        >
          {t(messages.detailsManufacturer.findDealerButton)}
        </a>
      </div>
    );
  }

  render() {
    // FIXME: (TPP-1626) Remove the cookies prop (unused).
    const {
      listing,
      isWorking,
      carouselClickCount,
      additionalLeadsModalOpen,
      boatLoansSection,
      ficoScores
    } = this.props;
    const {
      tridentTeaserRate,
      tridentLoanAmount,
      tridentTermInMonths,
      isLeadSubmitted
    } = this.props;
    const uom = get(this.context, 'uom.length.abbr');
    const customUom = this.getCustomUom();
    const seoConfig = get(this, 'context.pages.details.seo');
    const customMeta = get(this.context, 'supports.customMeta', false);
    const manufacturerListings = get(
      this.context,
      'supports.manufacturerListings',
      false
    );
    const targeting = getTargeting(
      listing,
      customUom && customUom.length ? customUom.length.abbr : uom
    );
    const breadCrumbItems = getBreadCrumb(listing, this.state.breakpoint);
    const pageAdsConfig = this.getPageAdsConfig();
    const adReload = Math.floor(carouselClickCount / 5) || 0;
    const showThirdAdbox = get(this, 'context.supports.showThirdAdBox', false);
    const secondAdBoxParams = this.getSecondAdParams(
      showThirdAdbox,
      adReload,
      adParams
    );
    const showBottomAdBox = get(
      this,
      'context.supports.showBottomAdBox',
      false
    );
    const portal = getPortalName(this.context);
    const DetailsSectionVariant = this.mapDetailsSectionVariants();
    const showManufacturerForm =
      manufacturerListings &&
      get(listing, 'isOemModel', false) &&
      get(listing, 'findDealerLink', '') !== '' &&
      get(listing, 'owner.logos.default', '') !== '';
    const revealDealerPhoneNumber = get(
      this.context,
      `languages.${this.props.intl.locale}.revealDealerPhoneNumber`,
      false
    );

    const enableDealerLocatorV2 = get(
      this,
      'context.supports.enableDealerLocatorV2',
      false
    );
    const featureFlagActive = get(getConfig(), 'supports.immersiveTour', false);
    const showImmersiveTour = featureFlagActive && !!getImmersiveTour(listing);

    const supportsSavedSearchOnBDP = get(
      this.context,
      'supports.savedSearchOnBDP',
      false
    );
    const monthlyPrice = calculateMonthlyPrice(
      tridentTeaserRate,
      tridentTermInMonths,
      tridentLoanAmount
    );
    const locale = getCurrentLocale();
    const supportsTridentCalculator = get(
      getConfig(),
      `languages.${locale}.supports.tridentCalculator`,
      false
    );
    const supportsMonthlyPayment = get(
      getConfig(),
      `languages.${locale}.supports.monthlyPayment`,
      false
    );
    const showLoansButton = boatLoansSection?.isValid ?? false;

    return (
      <>
        <ImmersiveTourModal
          isOpen={this.state.showImmersiveTourModal}
          closeModal={() =>
            this.setState({ ...this.state, showImmersiveTourModal: false })
          }
          title={immersiveTourHelper.getTitle(listing)}
          url={get(listing, 'virtualTour.url')}
        />
        <AdProvider
          url={get(this.props, 'location.pathname', '')}
          isWorking={this.props.isWorking}
          targeting={targeting}
          adsConfig={pageAdsConfig}
        >
          <Meta
            noindex={meta.getNoIndex()}
            canonical={meta.getCanonical(listing)}
            next={meta.getLinkRelNext()}
            prev={meta.getLinkRelPrev()}
            title={meta.getMetaTitle(listing, portal, seoConfig, customUom)}
            description={meta.getMetaDescription(listing, portal, customMeta)}
          />
          <ProductSchema
            listing={listing}
            labels={{
              getTitle: listingHelper.getTitle,
              getCurrency: getCurrency
            }}
          />
          <NextPreviousDataProvider {...this.props} />

          {/* Modal Contact Form */}
          {this.state.showContactModal && !showManufacturerForm && (
            <div
              className="details-contact-modal"
              id="bdp-default-contact-modal"
            >
              <div className="modal-wrapper">
                <DetailsContact
                  id="details-contact-modal-show"
                  isModal={true}
                  breakpoint={this.state.breakpoint}
                  listing={listing}
                  origin={this.state.contactOrigin}
                  scrolled={this.state.scrolled}
                  disableSticky
                  initialState="open"
                  revealDealerPhoneNumber={revealDealerPhoneNumber}
                  prePopulatedText={this.state.contactModal.prePopulatedText}
                  onClose={this.handleCloseContactModal}
                />
              </div>
            </div>
          )}

          {this.state.showContactModal &&
            this.checkIsEmailManufacturer() &&
            this.showManufacturerModal()}
          {/* Saved search popup */}
          {supportsSavedSearchOnBDP && (
            <SidePopUp
              listingId={listing.id}
              hideSavedSearchPopup={this.state.hideSavedSearchPopup}
              tracking={{ setGenericEvent: this.props.setGenericEvent }}
              portal={portal}
            >
              <SaveSearchFromDetails
                idPrefix="modal-save-search-section"
                data={listingHelper.getSavedSearchDetailsData(listing)}
                searchPath={listingHelper.getSavedSearchDetailsSearchPath(
                  listing
                )}
                createSearchAlert={this.props.createSearchAlert}
                tracking={{
                  setGenericEvent: this.props.setGenericEvent,
                  submitEvent: 'SaveSearchPopupSubscribed'
                }}
                listingId={listing.id}
                portal={portal}
              />
            </SidePopUp>
          )}

          {/* Modal Contact Form - Hidden by default */}
          <div className="details-contact-modal hide">
            <div className="modal-wrapper">
              <DetailsContact
                id="details-contact-modal-hide"
                isModal={true}
                breakpoint={this.state.breakpoint}
                listing={listing}
                origin={this.state.contactOrigin}
                disableSticky
                initialState="open"
                revealDealerPhoneNumber={revealDealerPhoneNumber}
                showManufacturerForm={
                  showManufacturerForm && this.checkIsEmailManufacturer()
                }
                onClose={this.handleCloseContactModal}
              />
            </div>
          </div>

          <div className="boat-details">
            <div id="root-anchor"></div>
            <NextPrevious
              listing={listing}
              breadCrumbs={breadCrumbItems}
              navLinks={this.props.navLinks}
              isLoading={isWorking}
              breakpoint={this.state.breakpoint}
              showInfo={this.state.scrolledPastBoatSummary}
              tracking={{ setGenericEvent: this.props.setGenericEvent }}
            />
            {this.state.breakpoint !== BREAKPOINTS.desktop && (
              <BreadCrumb items={breadCrumbItems} />
            )}
            <div className="top">
              {this.state.showModalCarousel && (
                <CarouselModal
                  device={this.state.breakpoint}
                  isLoading={isWorking}
                  listing={listing}
                  showThumbs={true}
                  show={this.state.showModalCarousel}
                  selectedCarouselItem={this.state.carouselIndex}
                  hideModal={this.hideModal}
                  adParams={adParams}
                  adReload={adReload}
                  isManufacturer={
                    showManufacturerForm && this.checkIsEmailManufacturer()
                  }
                />
              )}
              <div className="carousel-wrapper">
                <CarouselDisplayer
                  device={this.state.breakpoint}
                  isLoading={isWorking}
                  listing={listing}
                  showThumbs={false}
                  showModal={(index) => {
                    this.showModal(index);
                  }}
                />
                {this.state.breakpoint !== 'mobile' && (
                  <CarouselButtonTray
                    {...this.getCarouselButtonTrayProps(listing)}
                    onClickImmersiveTourButton={() =>
                      this.setState({
                        ...this.state,
                        showImmersiveTourModal: true
                      })
                    }
                    showImmersiveTour={showImmersiveTour}
                    handleOpenContactForm={this.handleOpenContactModal}
                    breakpoint={this.state.breakpoint}
                    showManufacturerForm={showManufacturerForm}
                  />
                )}
              </div>
              {this.state.breakpoint === 'mobile' && (
                <ButtonTray
                  {...this.getButtonTrayProps(listing)}
                  onClickImmersiveTourButton={() =>
                    this.setState({
                      ...this.state,
                      showImmersiveTourModal: true
                    })
                  }
                  showImmersiveTour={showImmersiveTour}
                  handleOpenContactForm={this.handleOpenContactModal}
                  breakpoint={this.state.breakpoint}
                />
              )}
              {this.state.breakpoint === 'mobile' && (
                <Ad
                  {...adParams.mobileLeaderboardParams}
                  reloadAd={adReload}
                  targeting={{ refresh: adReload.toString() }}
                />
              )}
              {showManufacturerForm &&
                this.state.breakpoint === BREAKPOINTS.desktop &&
                !this.state.showModalCarousel &&
                this.showManufacturerDetailsLayout()}

              {!showManufacturerForm &&
                this.state.breakpoint === BREAKPOINTS.desktop &&
                !this.state.showModalCarousel && (
                  <DetailsContact
                    id="details-contact-modal"
                    breakpoint={this.state.breakpoint}
                    isLoading={isWorking}
                    listing={listing}
                    disableSticky
                    initialState="open"
                    revealDealerPhoneNumber={revealDealerPhoneNumber}
                  />
                )}
            </div>
            <div className="body">
              <div className="boat-details-content">
                <>
                  <Ad
                    {...adParams.mobileLeaderboardParams}
                    reloadAd={adReload}
                    targeting={{ refresh: adReload.toString() }}
                  />
                  <Ad
                    {...adParams.leaderboardTopParams}
                    reloadAd={adReload}
                    targeting={{ refresh: adReload.toString() }}
                  />
                </>
                {this.state.breakpoint !== BREAKPOINTS.desktop &&
                  showManufacturerForm &&
                  this.showFindDealerButton()}

                <BoatSummary
                  breakpoint={this.state.breakpoint}
                  isLoading={isWorking}
                  onClickPaymentLink={this.handleSummaryPaymentLinkClicked}
                  onClickLocationLink={this.handleSummaryLocationLinkClicked}
                  onClickLoansButton={this.handleSummaryLoansButtonclicked}
                  listing={listing}
                  showLoansButton={showLoansButton}
                  customUom={customUom ? customUom.length : undefined}
                  monthlyPrice={monthlyPrice}
                  supportsTridentCalculator={supportsTridentCalculator}
                  supportsMonthlyPayment={supportsMonthlyPayment}
                />
                <Sticky
                  position="top"
                  offset={HEADER_OFFSET}
                  onChange={this.handleBoatSummaryScroll}
                />
                <DetailsSectionVariant
                  isLoading={isWorking}
                  listing={listing}
                  openPaymentSection={this.state.openPaymentComponent}
                  openPaymentCounter={this.state.openPaymentComponentCounter}
                  openLocationSection={this.state.openLocationComponent}
                  openLocationCounter={this.state.openLocationComponentCounter}
                  openBoatLoansSection={this.state.openBoatLoansComponent}
                  openBoatLoansCounter={
                    this.state.openBoatLoansComponentCounter
                  }
                  breakpoint={this.state.breakpoint}
                  onOpenContactForm={this.handleOpenContactModal}
                  adParams={adParams}
                  showManufacturerForm={showManufacturerForm}
                  customUom={customUom}
                  hideSavedSearchPopup={this.state.showContactModal}
                  setGenericEvent={this.props.setGenericEvent}
                  pageType={this.props.pageType}
                  boatLoansSection={this.props.boatLoansSection}
                  tridentTermInMonths={tridentTermInMonths}
                  tridentLoanAmount={tridentLoanAmount}
                  tridentTeaserRate={tridentTeaserRate}
                  showModalPreQualified={this.showModalPreQualified}
                  isLeadSubmitted={isLeadSubmitted}
                />
                {showBottomAdBox && (
                  <Ad {...adParams.leaderboardBottomParams} />
                )}
              </div>
              {this.state.breakpoint === 'desktop' && (
                <div className="right-ad">
                  <div className="sticky-ads">
                    <Ad
                      {...adParams.sideBarAd1Params}
                      reloadAd={adReload}
                      targeting={{ refresh: adReload.toString() }}
                    />
                    <Ad {...secondAdBoxParams} />
                    {showThirdAdbox && <Ad {...adParams.sideBarAd3Params} />}
                  </div>
                </div>
              )}
            </div>
            {this.state.breakpoint === 'mobile' && (
              <Ad {...adParams.mobileBox2Params} />
            )}
          </div>
          {(this.state.breakpoint === BREAKPOINTS.mobile ||
            (this.state.breakpoint === BREAKPOINTS.tablet &&
              !this.state.showModalCarousel)) && (
            <StickyContact
              isManufacturer={
                showManufacturerForm && this.checkIsEmailManufacturer()
              }
              isLoading={isWorking}
              listing={listing}
              onOpenContact={this.handleOpenContactModal}
            />
          )}
          {additionalLeadsModalOpen && <AdditionalLeadsModal />}
          {this.state.showVideoTourForm && (
            <LiveVideoTourModal
              listingId={listing.id}
              onClose={() => this.toggleVideoTourModal()}
            />
          )}
          {enableDealerLocatorV2 &&
            listing.oemDetails &&
            listing.oemDetails.dealerLocator && (
              <DealerLocator
                device={this.state.breakpoint}
                hideModal={() => this.toggleDealerLocatorModal(false)}
                isOpen={this.state.showDealerLocatorModal}
                oemDetails={listing.oemDetails}
                listing={listing}
                isWorking={this.props.isWorking}
                origin="bdp"
              />
            )}
          {this.state.showModalPreQualified && (
            <GetPreQualifiedModal
              onClose={() => this.showModalPreQualified(false)}
              isMobile={this.state.breakpoint === 'mobile'}
              interestRate={tridentTeaserRate}
              monthlyPrice={monthlyPrice}
              listing={listing}
              ficoScores={ficoScores}
              leadPage="BDP"
            />
          )}
        </AdProvider>
      </>
    );
  }
}

MainContent.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  isWorking: PropTypes.bool,
  listing: listingPropTypes,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }).isRequired,
  setGenericEvent: PropTypes.func.isRequired,
  clearEcommerceData: PropTypes.func.isRequired,
  setEnhancedEcommerce: PropTypes.func.isRequired,
  setProduct: PropTypes.func.isRequired,
  trackContactFormOpen: PropTypes.func.isRequired,
  openCarouselModal: PropTypes.func.isRequired,
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string,
    searchUrl: PropTypes.string
  }),
  carouselClickCount: PropTypes.number,
  additionalLeadsModalOpen: PropTypes.bool,
  setListingView: PropTypes.func.isRequired,
  createSearchAlert: PropTypes.func.isRequired,
  pageType: PropTypes.string,
  boatLoansSection: PropTypes.object,
  ficoScores: PropTypes.array,
  tridentTeaserRate: PropTypes.number,
  tridentLoanAmount: PropTypes.number,
  tridentTermInMonths: PropTypes.number,
  isLeadSubmitted: PropTypes.bool,
  abTestContext: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    userCountryCode: state.userCountryCode,
    additionalLeadsModalOpen: get(state, 'app.additionalLeads.open', false),
    isLeadSubmitted: get(state.app, 'trident.isLeadSubmitted', false)
  };
};

MainContent.contextType = PortalConfigContext;
const OemBDPWithCookies = withCookies(
  connect(mapStateToProps, (dispatch) =>
    bindActionCreators(
      {
        setGenericEvent,
        clearEcommerceData,
        setEnhancedEcommerce,
        setProduct,
        openCarouselModal,
        trackContactFormOpen,
        setListingView,
        createSearchAlert
      },
      dispatch
    )
  )(injectIntl(MainContent))
);

export default OemBDPWithCookies;
